"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var propTypes = {
  ariaAnnounceText: _propTypes["default"].string,
  children: _propTypes["default"].string,
  className: _propTypes["default"].string,
  compact: _propTypes["default"].bool,
  constantWidth: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  disabledOnLoading: _propTypes["default"].bool,
  href: _propTypes["default"].string,
  htmlButtonType: _propTypes["default"].oneOf(['button', 'submit', 'reset']),
  id: _propTypes["default"].string,
  loading: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  padding: _propTypes["default"].oneOf(['tiny', 'small', 'normal', 'medium', 'large', 'xlarge', 'xxlarge']),
  style: _propTypes["default"].objectOf(_propTypes["default"].string),
  type: _propTypes["default"].string
};
var defaultProps = {
  ariaAnnounceText: 'Loading, please wait...',
  children: '',
  compact: false,
  constantWidth: true,
  disabled: false,
  disabledOnLoading: true,
  htmlButtonType: 'button',
  loading: false,
  onClick: function onClick() {},
  type: 'action'
};

var Button = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Button, _Component);

  function Button(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.node = void 0;

    _this.setWidth = function (width) {
      _this.setState({
        width: width
      });
    };

    _this.node = /*#__PURE__*/_react["default"].createRef();
    _this.state = {};
    return _this;
  }

  var _proto = Button.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var constantWidth = this.props.constantWidth;

    if (constantWidth && this.node.current) {
      this.setWidth(this.node.current.offsetWidth);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var constantWidth = this.props.constantWidth;

    if (!constantWidth && prevProps.constantWidth) {
      this.setWidth(undefined);
    } else if (constantWidth && !prevProps.constantWidth) {
      this.setWidth(this.node.current.offsetWidth);
    }
  };

  _proto.render = function render() {
    var _classNames;

    var _this$props = this.props,
        children = _this$props.children,
        compact = _this$props.compact,
        onClick = _this$props.onClick,
        type = _this$props.type,
        disabled = _this$props.disabled,
        className = _this$props.className,
        style = _this$props.style,
        id = _this$props.id,
        loading = _this$props.loading,
        disabledOnLoading = _this$props.disabledOnLoading,
        ariaAnnounceText = _this$props.ariaAnnounceText,
        href = _this$props.href,
        htmlButtonType = _this$props.htmlButtonType,
        constantWidth = _this$props.constantWidth,
        padding = _this$props.padding,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["children", "compact", "onClick", "type", "disabled", "className", "style", "id", "loading", "disabledOnLoading", "ariaAnnounceText", "href", "htmlButtonType", "constantWidth", "padding"]);

    var width = this.state.width;
    var classes = (0, _classnames["default"])('grv-button', "grv-button--" + type, (_classNames = {
      'grv-button--compact': compact,
      'grv-button--loading': loading,
      'grv-button--loading-active': loading
    }, _classNames["grv-button--padding-" + padding] = padding, _classNames), className);
    var ariaClasses = (0, _classnames["default"])({
      'grv-button__announce': loading,
      'grv-button__announce--active': loading
    });
    var ariaId = id + "-announce";
    var sharedProps = Object.assign({}, otherProps, {
      className: classes,
      disabled: disabled || (disabledOnLoading ? loading : false),
      id: id,
      onClick: onClick,
      ref: this.node,
      style: width ? Object.assign({
        width: width
      }, style) : style
    });
    var button = href ? /*#__PURE__*/_react["default"].createElement("a", _extends({}, sharedProps, {
      href: href
    }), children) : /*#__PURE__*/_react["default"].createElement("button", _extends({}, sharedProps, {
      type: htmlButtonType
    }), children);
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, button, loading ? /*#__PURE__*/_react["default"].createElement("span", {
      "aria-live": "assertive",
      className: ariaClasses,
      id: ariaId,
      role: "alert"
    }, ariaAnnounceText) : undefined);
  };

  return Button;
}(_react.Component);

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
var _default = Button;
exports["default"] = _default;